import CommonType from "./actionTypes"

const INIT_STATE = {
  igarashiInfo: {
    loading: true,
    data: {}
  }
}

const Common = (state = INIT_STATE, action) => {
  switch (action.type) {
    case CommonType.GET_INFO_IGARASHI_SUCCESS:
      return {
        ...state,
        igarashiInfo: action.payload,
      }
    default:
      return state
  }
}

export default Common
